import { render, staticRenderFns } from "./mathJax.vue?vue&type=template&id=2dfa1dad&"
import script from "./mathJax.vue?vue&type=script&lang=js&"
export * from "./mathJax.vue?vue&type=script&lang=js&"
import style0 from "./mathJax.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports